import React, { useEffect } from "react";
import { usePage } from "@inertiajs/react";
import toast, { Toaster } from "react-hot-toast";
import Navbar from "@/components/navbar/Navbar";

interface LayoutProps {
  children: React.ReactNode;
  wide?: boolean;
}

export type PageWithLayout<P> = React.FC<P> & {
  layout?: (page: React.ReactNode) => React.ReactNode;
};

export const wideLayout = (page: React.ReactNode) => (
  <Layout wide>{page}</Layout>
);

export default function Layout({ children, wide = false }: LayoutProps) {
  const { flash, user } = usePage().props as any;

  useEffect(() => {
    if (flash.notice) toast.success(flash.notice);
  }, [flash.notice]);

  useEffect(() => {
    if (flash.alert) toast.error(flash.alert);
  }, [flash.alert]);

  return (
    <div className="bg-cream-100 text-cream-900 dark:bg-cream-900 dark:text-cream-100 flex min-h-screen flex-col">
      {user && <Navbar wide={wide} />}
      <main
        className={`mx-auto flex w-full flex-1 px-4 py-10 sm:px-6 lg:px-8 ${
          wide ? "max-w-page" : "max-w-content"
        }`}
      >
        <Toaster />
        {children}
      </main>
    </div>
  );
}
